import { Injectable } from "@angular/core";
import { DownloadModalStatus } from "../models/global-interface";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})

export class DownloadModalService {
  private initialState: DownloadModalStatus = {
    type: 'check',
    id: '',
    institutionName: '',
    wardName: '',
    departmentName: '',
    creationHour: '',
    creationDate: '',
    username: '',
  };

  private downloadModalSubject = new BehaviorSubject<DownloadModalStatus>(this.initialState);
  private closeModalSubject = new BehaviorSubject<boolean>(false);
  public downloadModal$ = this.downloadModalSubject.asObservable();
  public closeModal$ = this.closeModalSubject.asObservable();

  constructor() { }

  setDownloadModal(status: DownloadModalStatus) {
    this.downloadModalSubject.next(status);
  }

  closeAndDeleteModal() {
    this.closeModalSubject.next(true);
  }
}